import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Perfil } from '../types';
import { perfilPermitido, usePerfil } from '../hooks/usePerfil';

/**
 * Mostra a página só para os perfis da lista; os outros vão para `senao`. É só a
 * tela: quem barra de verdade é o back.
 */
export function SoPerfis({ perfis, senao, children }: { perfis: Perfil[]; senao: string; children: ReactNode }) {
    const { perfil } = usePerfil();
    // Enquanto o /auth/me não chegou, não redireciona ninguém por engano.
    if (perfil && !perfilPermitido(perfis, perfil)) return <Navigate to={senao} replace />;
    return <>{children}</>;
}
